module.exports = __webpack_public_path__ + "static/media/sos-exatas.f7abb697.png";